import { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const PRIORITY_COLORS = {
  critica: '#FF3B30',
  alta: '#FF9F0A',
  media: '#FFD60A',
  bassa: '#32D74B',
};

function createMarkerIcon(color) {
  return L.divIcon({
    className: 'custom-marker',
    html: `<div style="width:14px;height:14px;border-radius:50%;background:${color};border:2px solid white;box-shadow:0 0 8px ${color}80;"></div>`,
    iconSize: [14, 14],
    iconAnchor: [7, 7],
  });
}

export default function MapView({ requests = [], height = '400px', center = [41.9028, 12.4964], zoom = 6, onMarkerClick }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;

    const map = L.map(mapRef.current, {
      center,
      zoom,
      zoomControl: true,
      attributionControl: false,
    });

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
      maxZoom: 19,
    }).addTo(map);

    mapInstanceRef.current = map;

    return () => {
      map.remove();
      mapInstanceRef.current = null;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!map) return;

    markersRef.current.forEach(m => map.removeLayer(m));
    markersRef.current = [];

    requests.forEach((req) => {
      if (req.latitudine && req.longitudine) {
        const marker = L.marker([req.latitudine, req.longitudine], {
          icon: createMarkerIcon(PRIORITY_COLORS[req.priorita] || '#A0A0A0')
        }).addTo(map);

        marker.bindPopup(`
          <div style="font-family:sans-serif;font-size:12px;color:#0D1B2A;background:#fff;padding:8px;border:1px solid #B8D4E8;min-width:150px;">
            <strong style="text-transform:uppercase;letter-spacing:1px;">${req.categoria?.replace(/_/g, ' ')}</strong>
            <br/><span style="color:${PRIORITY_COLORS[req.priorita]};font-size:10px;text-transform:uppercase;">${req.priorita}</span>
            <br/><span style="color:#4A6B8A;font-size:11px;">${req.descrizione?.substring(0, 80) || ''}</span>
            ${req.indirizzo ? `<br/><span style="color:#6B8AB5;font-size:10px;">${req.indirizzo}</span>` : ''}
          </div>
        `, { className: 'dark-popup' });

        if (onMarkerClick) {
          marker.on('click', () => onMarkerClick(req));
        }

        markersRef.current.push(marker);
      }
    });
  }, [requests, onMarkerClick]);

  return (
    <div
      ref={mapRef}
      style={{ height, width: '100%' }}
      className="border border-[#2A2A2A]"
      data-testid="map-view"
    />
  );
}
